import { enableProdMode, provideZonelessChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@env/environment';
import { AppModule } from '@app/app.module';
import { registerAgGridModules } from '@app/advanced-reports/ag-grid-module-register';
import { provideApplicationErrorHandling } from '@logging/provide-application-error-handling';

registerAgGridModules();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZonelessChangeDetection(), provideApplicationErrorHandling()] })
  .catch((err) => console.error(err));
